import { RouterManager } from '@aclass/admin/managers';
import { OverviewStory } from '@aclass/admin/storage/actions';
import { IAdminState, IOverviewModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class OverviewCreateStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:overview-create';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IOverviewModuleState['createPageInitialized']>(['overviewModule', 'createPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(OverviewCreateStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(OverviewStory.dryRunCreatePage());
    }
}
